import { createContext, useContext, useEffect, useState } from "react";
import { getToken, getUserRole, clearToken, getUserId, getUserName, setToken } from "./services/auth";
import { clearDesignV2Preview } from "shared/utils/designV2";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [role, setRole] = useState(null);
    const [userId, setUserId] = useState(null);
    const [name, setName] = useState(null);

    useEffect(() => {
        const token = getToken();

        if (token) {
            setIsAuthenticated(true);
            setRole(getUserRole());
            setUserId(getUserId());
            setName(getUserName());
        } else {
            setIsAuthenticated(false);
            setRole(null);
            setUserId(null);
            setName(null);
        }

        setLoading(false);
    }, []);

    const login = (token) => {
        setToken(token);
        setIsAuthenticated(true);
        const userRole = getUserRole();
        setRole(userRole);
        setUserId(getUserId());
        setName(getUserName());

        if (userRole !== "admin") {
            clearDesignV2Preview();
        }
    };

    const logout = () => {
        clearToken();
        setIsAuthenticated(false);
        setRole(null);
        setUserId(null);
        setName(null);
        clearDesignV2Preview();
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, role, userId, name, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);